import { useEffect, useState, type CSSProperties } from "react";

function prefersReducedMotion(): boolean {
  return typeof window !== "undefined" && (window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false);
}

/**
 * Um número que entra como placar de redação (2026-10-16): cada dígito é um
 * rolo de 0 a 9 que gira até o valor, um pouco depois do anterior. O TEXTO do
 * dígito continua na página (transparente), e o rolo é desenhado por CSS por
 * cima (`.rolling-digit::before`) — então o que se lê, copia e testa é o
 * valor real. Vírgula, ponto e "—" ficam parados; quem pede menos movimento
 * recebe o número pronto.
 */
export function RollingNumber({ value, delay = 0 }: { value: string; delay?: number }) {
  const [rolled, setRolled] = useState(prefersReducedMotion);

  useEffect(() => {
    if (rolled) return;
    // Dois quadros: o primeiro pinta os rolos no zero, o segundo dispara o giro.
    let second = 0;
    const first = requestAnimationFrame(() => {
      second = requestAnimationFrame(() => setRolled(true));
    });
    return () => {
      cancelAnimationFrame(first);
      cancelAnimationFrame(second);
    };
  }, [rolled]);

  const chars = [...value];
  const digitCount = chars.filter(char => /\d/.test(char)).length;
  let position = 0;

  return (
    <span className="rolling-number">
      {chars.map((char, index) => {
        if (!/\d/.test(char)) return char;
        const order = position++;
        const style = {
          "--d": rolled ? Number(char) : 0,
          // O último dígito gira por mais tempo, como um placar assentando.
          "--roll-ms": `${900 + (digitCount - order) * 150}ms`,
          "--roll-delay": `${delay + order * 70}ms`
        } as CSSProperties;
        return <span key={index} className="rolling-digit" style={style}>{char}</span>;
      })}
    </span>
  );
}
